export const CALENDAR_EXTRACTION_VERSION = 2;
